module.exports = __webpack_public_path__ + "static/media/night_hdri_3.d725a9d1.hdr";